import React from 'react'

function SplitCard({topImage,topName,onTopClick,bottomImage,bottomName,onBottomClick,wrapperClassName}) {

    return (
        <div className={`col-lg-4 col-6 d-flex flex-column justify-content-center${wrapperClassName ? ' ' + wrapperClassName : ''}`}>
            <div className="panel-card panel-card-split d-flex flex-column justify-content-center">
                <div className="panel-card-split-half" onClick={onTopClick}>
                    <img src={topImage} className="card-img-top" alt="خطا"/>
                    <h3>{topName}</h3>
                </div>
                <div className="panel-card-split-divider"></div>
                <div className="panel-card-split-half" onClick={onBottomClick}>
                    <img src={bottomImage} className="card-img-top" alt="خطا"/>
                    <h3>{bottomName}</h3>
                </div>
            </div>
        </div>
    );
}

export default SplitCard;
